import FanRequestMediaPage from "./FanRequestMediaPage";

export default FanRequestMediaPage;
